import sanitizeHtml from "sanitize-html";

export const sanitizeNoHtmlTagContent = (dirty: string) => {
    var result = sanitizeHtml(dirty, {
        allowedTags: [],
        allowedAttributes: {},
    });

    return result;
};